
export function BrandWordmark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1133.44 182.82"
      className="brand-wordmark-svg"
      role="img"
      aria-label="Reputaition"
    >
      <defs>
        <mask id="brand-ai-mask">
          <g fill="#ffffff">
            {/* Estrela de brilho sobre o i de ai */}
            <path d="M621.66,15.42l-4.61-1.32c-4.22-1.19-7.52-4.49-8.71-8.71l-1.32-4.61c-.18-.45-.7-.66-1.15-.48-.22.09-.39.26-.48.48l-1.32,4.61c-1.19,4.22-4.49,7.52-8.71,8.71l-4.61,1.32c-.45.13-.71.59-.58,1.04.08.28.3.5.58.58l4.61,1.32c4.22,1.19,7.52,4.49,8.71,8.71l1.32,4.61c.13.45.59.71,1.04.58.28-.08.5-.3.58-.58l1.32-4.61c1.19-4.22,4.49-7.52,8.71-8.71l4.61-1.32c.45-.13.71-.59.58-1.04-.08-.28-.3-.5-.58-.58Z" />
            {/* Letra a */}
            <path d="M563.7,132.24h-.21c-6.38,8.23-17.28,16.87-35.37,16.87-20.15,0-35.99-9.46-35.99-29.62,0-25.09,19.74-30.23,46.27-34.34,15.01-2.26,25.5-3.7,25.5-15.22s-8.64-18.71-23.86-18.71c-17.28,0-25.91,7.4-26.53,23.44h-16.04c.62-20.57,14.19-35.99,42.37-35.99,22.62,0,39.28,8.43,39.28,33.73v50.59c0,8.64,2.06,13.37,11.31,11.31h.62v12.13c-2.06.82-4.73,1.64-9.05,1.64-10.9,0-16.66-4.94-18.3-15.84ZM564.11,107.76v-18.1c-5.55,3.5-15.22,6.17-24.27,7.81-16.66,3.09-30.03,5.96-30.03,21.59,0,14.19,11.11,17.28,22,17.28,22.21,0,32.29-16.25,32.29-28.59Z" />
            {/* Haste da letra i */}
            <path d="M598.25,40.72h16.66v106.33h-16.66V40.72Z" />
          </g>
        </mask>
      </defs>

      {/* Ícone circular com a estrela à esquerda */}
      <path
        className="brand-wordmark-static"
        d="M75.22,0C33.68,0,0,33.68,0,75.22s33.68,75.22,75.22,75.22,75.22-33.68,75.22-75.22S116.77,0,75.22,0ZM144.51,75.23c-18.33,5.21-31.98,17.91-38.97,39.46-8.86-24.87-26.5-32.59-62.43-36.89-16.52-1.97-27.49-2.44-36.06-2.56h-1.17c.19,0,.39-.01.59-.01-.2,0-.4,0-.59-.01h1.17c8.57-.13,19.54-.59,36.06-2.56,35.93-4.3,53.57-12.01,62.43-36.89,7,21.55,20.65,34.25,38.97,39.46h.05s-.02.01-.02.01c0,0,.01.01.02.01h-.05Z"
      />
      <g transform="translate(214.16 1.64)">
        {/* R */}
        <path
          className="brand-wordmark-static"
          d="M0,0h68.69c25.91,0,43.39,16.25,43.39,40.31,0,17.89-7.81,30.64-25.5,36.4v.62c15.01,5.35,19.74,15.63,21.18,37.43,1.64,23.65,4.11,29.62,6.79,31.47v.82h-19.95c-3.08-2.67-3.7-8.23-5.35-32.91-1.44-21.59-10.08-29.2-29.82-29.2H18.51v62.11H0V0ZM18.51,69.92h43.6c20.57,0,30.85-10.28,30.85-26.94,0-17.89-26.94-26.94-29.82-26.94H18.51v53.88Z"
        />
        {/* e */}
        <path
          className="brand-wordmark-static"
          d="M119.9,93.99c0-30.85,20.15-55.94,50.39-55.94,31.88,0,48.95,24.68,48.95,59.85h-82.26c1.23,21.59,12.96,38.05,34.35,38.05,15.42,0,25.71-7.4,29.41-21.8h16.25c-4.94,22.83-21.59,35.79-45.66,35.79-32.49,0-51.41-25.09-51.41-55.94ZM137.38,85.35h63.96c-1.03-21.18-11.93-34.14-31.05-34.14s-30.44,14.81-32.91,34.14Z"
        />
        {/* p */}
        <path
          className="brand-wordmark-static"
          d="M230.33,40.72h16.66v15.01h.41c8.02-10.9,18.71-17.48,34.14-17.48,26.94,0,45.66,20.57,45.66,55.94s-17.48,55.94-46.27,55.94c-14.4,0-24.68-4.32-33.52-15.63h-.41v46.68h-16.66V40.72ZM310.13,94.4c0-23.86-10.08-41.96-30.23-41.96-23.24,0-33.93,18.92-33.93,41.96s9.25,41.75,33.73,41.75c20.36,0,30.44-17.69,30.44-41.75Z"
        />
        {/* u */}
        <path
          className="brand-wordmark-static"
          d="M406.38,147.05v-14.6h-.41c-7.61,10.28-16.66,17.07-32.08,17.07-21.8,0-35.78-13.16-35.78-35.17V40.72h16.66v73.21c0,13.78,8.84,21.8,23.86,21.8,16.86,0,27.76-12.75,27.76-29.61V40.72h16.66v106.33h-16.66Z"
        />
        {/* t */}
        <path
          className="brand-wordmark-static"
          d="M433.73,40.72h15.42V7.2h16.66v33.52h20.57v13.57h-20.57v69.1c0,7.4,3.91,9.87,10.69,9.87,3.29,0,6.99-.82,8.84-1.44h.62v14.4c-3.91.82-8.43,1.44-13.37,1.44-13.57,0-23.45-5.55-23.45-20.57V54.29h-15.42v-13.57Z"
        />

        {/* PARTE "ai" COM MÁSCARA E DEGRADÊ DIAGONAL EM VARREDURA */}
        <foreignObject x="480" y="0" width="160" height="180" mask="url(#brand-ai-mask)">
          <div className="brand-wordmark-ai-sweep" />
        </foreignObject>

        {/* t */}
        <path
          className="brand-wordmark-static"
          d="M625.6,40.72h15.42V7.2h16.66v33.52h20.57v13.57h-20.57v69.1c0,7.4,3.91,9.87,10.69,9.87,3.29,0,6.99-.82,8.84-1.44h.62v14.4c-3.91.82-8.43,1.44-13.37,1.44-13.57,0-23.45-5.55-23.45-20.57V54.29h-15.42v-13.57Z"
        />
        {/* i */}
        <path
          className="brand-wordmark-static"
          d="M690.38,40.72h16.66v106.33h-16.66V40.72Z"
        />
        {/* o */}
        <path
          className="brand-wordmark-static"
          d="M718.56,93.99c0-30.85,19.74-55.94,51.42-55.94s51.21,25.09,51.21,55.94-19.33,55.94-51.21,55.94-51.42-25.09-51.42-55.94ZM804.11,93.99c0-23.45-11.52-42.16-34.14-42.16s-34.34,18.71-34.34,42.16,11.72,41.96,34.34,41.96,34.14-18.51,34.14-41.96Z"
        />
        {/* n */}
        <path
          className="brand-wordmark-static"
          d="M849.35,54.71h.41c7.61-10.08,18.3-16.45,33.73-16.45,22.21,0,35.79,12.13,35.79,34.14v74.65h-16.66v-73.21c0-13.78-9.05-21.59-24.06-21.59-16.86,0-29.2,11.93-29.2,29.41v65.4h-16.66V40.72h16.66v13.99Z"
        />
      </g>
    </svg>
  );
}
